export const changeLoginLinkText = () => {
  const loginLink = document.querySelector('#footer-login');
  if (!loginLink || !store.get('isLoggedIn')) return;
  loginLink.textContent = backEndVars.tm237;
  loginLink.dataset.e2e = 'footer-meal-plan';
};

document.addEventListener('DOMContentLoaded', changeLoginLinkText);
